module.exports = __webpack_public_path__ + "static/media/cambodia.88783cef.svg";